import api from "./api";

/**
 * Bildirim uçları (backend: /api/notifications). SMS hatırlatma vb.
 * Sağlayıcı backend'de seçilir (mock/twilio); frontend sadece tetikler.
 */
export const notificationService = {
  smsReminder: (appointmentId) => api.post(`/notifications/appointments/${appointmentId}/sms-reminder`),
};
